import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    queue: [
      "https://www.youtube.com/watch?v=ROMEPVGOE50",
      "https://www.youtube.com/watch?v=3YW65K6LcIA",
      "https://www.youtube.com/watch?v=-jT6zKt2L5A",
      "https://www.youtube.com/watch?v=yFOdkyaoUTg",
    ],
    queueIdx: 0,
    roomCode: "QD75GH",
  },
  getters: {
    getQueue: (state) => {
      return state.queue;
    },
    getQueueIdx: (state) => {
      return state.queueIdx;
    },
    getRoomCode: (state) => {
      return state.roomCode;
    },
  },
  mutations: {
    addToQueue(state, url) {
      state.queue.push(url);
    },
    changeQueueIdx(state, idx) {
      state.queueIdx = idx;
    },
    setRoomCode(state, roomCode) {
      state.roomCode = roomCode;
    },
  },
  actions: {
    addToQueue(context, url) {
      context.commit("addToQueue", url);
    },
    changeQueueIdx(context, idx) {
      context.commit("changeQueueIdx", idx);
    },
    setRoomCode(context, roomCode) {
      context.commit("setRoomCode", roomCode);
    },
  },
});
